const resources = {
    signInLead: 'Sign in for FREE Shipping',
    signInCTA: 'Sign In',
    signUpLead: 'Don’t have an account?',
    signUpCTA: 'Create an Account',
    status: 'You’re a',
    points: 'with',
    join: 'Join Beauty Insider',
    earn: 'to earn points with every purchase.'
};

module.exports = function getResource(label, vars = []) {
    return resources[label];
};
